import React from "react";

export type IconProps = {
  name: string,
  regular?: boolean,
  solid?: boolean,
  duotone?: boolean,
  brand?: boolean,
  label?: string,
  tag?: "h1" | "h2" | "h3" | "h4" | "h5" | "p",
  className?: string
}

export const Icon = ({ name, regular, solid, duotone, brand, label, tag, className }: IconProps) => {
  const style = regular
      ? "far"
      : solid
          ? "fas"
          : duotone
              ? "fad"
              : brand
                  ? "fab"
                  : "fal";

  return (
      <i className={`${style} ${tag} ${className} fa-${name} pt-icon ${label}`}>
        <style>{`
        .pt-icon::before {
          vertical-align: middle;
        }
      `}</style>
      </i>
  );
};